import { useState } from 'react';

const usePasswordInput = (): [string, () => void] => {
    const [type, setType] = useState<string>('password');

    const toggleType = () => {
        setType((prev) => {
            if (prev === 'password') return 'text';
            else if (prev === 'text') return 'password';
        });
    };

    return [type, toggleType];
};

export default usePasswordInput;
